import React from "react";

// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// core components
import Header from "components/Header/Header.js";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import { Link } from "@material-ui/core";

const useStyles = makeStyles(headersStyle);

export default function SectionHeaders({ ...rest }) {
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };
  const smoothScroll = (target) => {
    var targetScroll = document.getElementById(target);

    var targetOffTop = null;
    switch (target) {
      case "header":
        targetOffTop = targetScroll.offsetTop;
        break;
      case "promotion":
        targetOffTop = targetScroll.offsetTop + 300;
        break;
      case "shop":
        targetOffTop = targetScroll.offsetTop + 500;
        break;
      case "about":
        targetOffTop = targetScroll.offsetTop + 600;
        break;
      case "contact":
        targetOffTop = targetScroll.offsetTop;
        break;
      default:
        targetOffTop = targetScroll.offsetTop;
    }

    scrollGo(document.documentElement, targetOffTop, 1250);
  };
  const scrollGo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function () {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };

  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    // we've set the className to cd-section so we can make smooth scroll to it
    <div className="cd-section" {...rest}>
      {/* HEADER 1 START */}
      <div>
        <Header
          absolute
          brand="Mercurytshirt"
          color="transparent"
          links={
            <div className={classes.collapse}>
              <List className={classes.list + " " + classes.mlAuto}>
                <ListItem className={classes.listItem}>
                  <Link
                    href="#header"
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      textDecorationColor: "#E91E63",
                      textDecorationThickness: 5,
                    }}
                    className={classes.navLink}
                    onClick={(e) => {
                      var isMobile = navigator.userAgent.match(
                        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
                      );
                      if (isMobile) {
                        // if we are on mobile device the scroll into view will be managed by the browser
                        e.preventDefault();
                        smoothScroll("header");
                      } else {
                        e.preventDefault();
                        smoothScroll("header");
                      }
                    }}
                  >
                    Home
                  </Link>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Link
                    href="#promotion"
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      textDecorationColor: "#E91E63",
                      textDecorationThickness: 5,
                    }}
                    className={classes.navLink}
                    onClick={(e) => {
                      var isMobile = navigator.userAgent.match(
                        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
                      );
                      if (isMobile) {
                        // if we are on mobile device the scroll into view will be managed by the browser
                        e.preventDefault();
                        smoothScroll("promotion");
                      } else {
                        e.preventDefault();
                        smoothScroll("promotion");
                      }
                    }}
                  >
                    Promotion
                  </Link>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Link
                    href="#shop"
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      textDecorationColor: "#E91E63",
                      textDecorationThickness: 5,
                    }}
                    className={classes.navLink}
                    onClick={(e) => {
                      var isMobile = navigator.userAgent.match(
                        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
                      );
                      if (isMobile) {
                        // if we are on mobile device the scroll into view will be managed by the browser
                        e.preventDefault();
                        smoothScroll("shop");
                      } else {
                        e.preventDefault();
                        smoothScroll("shop");
                      }
                    }}
                  >
                    Shop now
                  </Link>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Link
                    href="#about"
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      textDecorationColor: "#E91E63",
                      textDecorationThickness: 5,
                    }}
                    className={classes.navLink}
                    onClick={(e) => {
                      var isMobile = navigator.userAgent.match(
                        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
                      );
                      if (isMobile) {
                        // if we are on mobile device the scroll into view will be managed by the browser
                        e.preventDefault();
                        smoothScroll("about");
                      } else {
                        e.preventDefault();
                        smoothScroll("about");
                      }
                    }}
                  >
                    About us
                  </Link>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Link
                    href="#contact"
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      textDecorationColor: "#E91E63",
                      textDecorationThickness: 5,
                    }}
                    className={classes.navLink}
                    onClick={(e) => {
                      var isMobile = navigator.userAgent.match(
                        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
                      );
                      if (isMobile) {
                        // if we are on mobile device the scroll into view will be managed by the browser
                        e.preventDefault();
                        smoothScroll("contact");
                      } else {
                        e.preventDefault();
                        smoothScroll("contact");
                      }
                    }}
                  >
                    Contact us
                  </Link>
                </ListItem>
              </List>
              <List className={classes.list + " " + classes.mlAuto}>
                <ListItem className={classes.listItem}>
                  <Button
                    rel="noopener"
                    color="transparent"
                    href="https://web.facebook.com/mercurytshirt?_rdc=1&_rdr"
                    target="_blank"
                    className={classes.navLink + " " + classes.navLinkJustIcon}
                  >
                    <i className={"fab fa-facebook"} />
                  </Button>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Button
                    rel="noopener"
                    color="transparent"
                    href="https://page.line.me/mercurytshirt.com?openQrModal=true"
                    target="_blank"
                    className={classes.navLink + " " + classes.navLinkJustIcon}
                  >
                    <i className={"fab fa-line"} />
                  </Button>
                </ListItem>
              </List>
            </div>
          }
        />
        <Carousel {...settings}>
          {/* Carousel 1 START */}
          <div aria-hidden="true">
            <Parallax
              className={classes.pageHeader}
              image={require("assets/img/bg1.jpg").default}
            >
              <div className={classes.container}>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={6}>
                    <h1
                      className={classes.title}
                      style={{ fontFamily: "Kanit" }}
                    >
                      เมอร์คิวรี่ ทีเชิ้ต
                    </h1>
                    <h4>
                      ร้านเสื้อยืดเมอร์คิวรี่ ทีเชิ้ต ขายปลีก-ส่งเสื้อยืดสีพื้น
                      และเสื้อสกรีน สินค้าผลิตจากในไทย มีพร้อมจัดส่งทันที
                      การันตีรับประกันสินค้าคุณภาพ ติดต่อร้านได้ง่าย
                      มีแอดมินดูแล 24 ชั่วโมง เสื้อยืดของเรามีทั้งหมดกว่า 20 สี
                      มีทั้งคอกลมและคอวีสินค้าเป็นทรงตรงสามารถใส่ได้ทั้งผู้หญิงและผู้ชาย
                    </h4>
                    <br />
                    <Button
                      rel="noopener"
                      style={{ backgroundColor: "#3B5998", margin: 10 }}
                      size="lg"
                      href="https://web.facebook.com/mercurytshirt?_rdc=1&_rdr"
                      target="_blank"
                    >
                      <i className={"fab fa-facebook"} />
                      Facebook
                    </Button>
                    <Button
                      rel="noopener"
                      style={{ backgroundColor: "#00c402", margin: 10 }}
                      size="lg"
                      href="https://page.line.me/mercurytshirt.com?openQrModal=true"
                      target="_blank"
                    >
                      <i className={"fab fa-line"} />
                      Line
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
                    <div className={classes.iframeContainer}>
                      <iframe
                        height="250"
                        src="https://www.youtube.com/embed/BGT65W6Al_U"
                        frameBorder="0"
                        allow="encrypted-media"
                        allowFullScreen=""
                        title="Tesla"
                      />
                    </div>
                  </GridItem>
                </GridContainer>
              </div>
            </Parallax>
          </div>
          {/* Carousel 1 END */}
          {/* Carousel 2 START */}
          <div>
            <Parallax
              className={classes.pageHeader}
              image={require("assets/img/bg2.jpg").default}
            ></Parallax>
          </div>
          {/* Carousel 2 END */}
        </Carousel>
      </div>
    </div>
  );
}
